var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('scroll-top-button'),(_vm.$route.name != 'Fatura')?_c('heade'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath}),(_vm.$route.name != 'Fatura')?_c('foote'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }